// Display Error Modal component

import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { Modal, ModalHeader, ModalContent, ModalFooter, PrimaryButton } from '@/components/ui';

interface ErrorModalProps {
    open: boolean;
    onClose: () => void;
    error: string;
};

export const ErrorModal: React.FC<ErrorModalProps> = ({
    open,
    onClose,
    error
}) => {

    return (
        <Modal isOpen={open} onClose={onClose} variant='confirmation' size="sm" backdrop='blur'>
            <ModalHeader
                icon={<ExclamationTriangleIcon className="w-6 h-6 text-blue-600" />}
                title="An error has occurred"
                subtitle=""
                onClose={onClose}
            />
            <ModalContent padding={false} className="overflow-y-auto">
                <div className="flex items-center justify-center h-24">
                    <p className="mt-1 text-sm text-red-600 flex items-center">
                        Error: {error}
                    </p>
                </div>
            </ModalContent>
            <ModalFooter justify='end'>
                <div className="flex items-center">
                    <PrimaryButton onClick={onClose}>OK</PrimaryButton>
                </div>
            </ModalFooter>
        </Modal>
    );
};